<template>
  <div>
    <div class="form-group">
      <label for="registry" class="form-label">Matrícula</label>
      <input id="registry" type="tel" class="form-input" name="registry" value="" required autofocus v-model="registry"
        placeholder="xxxxxxxxx" />
    </div>

    <div class="form-group">
      <label for="password" class="form-label">Senha</label>
      <input id="password" type="password" class="form-input" name="password" required v-model="password"
        placeholder="******" />
    </div>

    <div class="form-group">
      <div class="block m-b-sm text-right m-r-lg">
        <span style="font-size: 14px; float: left; margin-top: -2px" class="m-l-lg">
          <input type="checkbox" /> Lembre-me
        </span>

        <a href="" data-toggle="modal" data-target="#myModal" style="font-size: 14px">Redefinir/Esqueci minha Senha</a>
      </div>

      <button type="submit" class="form-button" @click="login">
        <i class="fa fa-sign-in"></i> Entrar
      </button>
    </div>

    <div id="myModal" class="modal fade" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title">Formulário de Recuperação de Senha</h4>
          </div>

          <div class="modal-body">
            <form action="">
              <div class="form-group">
                <label for="">E-mail</label>
                <input type="email" name="email" class="form-control email" v-model="forgot.email" />
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" @click="forgotPassword">
              Solicitar Recuperação
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      registry: "",
      password: "",
      forgot: {
        email: "",
      },
    };
  },
  methods: {
    login() {
      const self = this;
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          registry: self.registry,
          password: self.password,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          self.$router.push({ path: "/" });
        })
        .catch((error) => {
          // Usando SweetAlert para exibir o título "Erro" e a mensagem vinda do backend
          swal({
            title: "Erro",
            text: error.response.data.message || "Algo deu errado ao tentar fazer o login.",
            icon: "error",
            button: "Ok",
          });
        });
    },


    forgotPassword() {

      const self = this;
      const api = this.$store.state.api + "user/recovery";

      const fd = new FormData();
      fd.append('email', self.forgot.email);

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Solicitação realizada com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });


    },
  },
};
</script>

<style>
body {
  font-family: "Roboto", sans-serif;
}

.form-input {
  width: 90% !important;
  font-size: 15px !important;
  padding: 10px !important;
  border: 1px solid #c0c0c0;
}

.form-label {
  width: 90% !important;
  display: block;
  text-align: left;
  font-size: 16px !important;
  margin-left: auto;
  margin-right: auto;
}

.form-button {
  width: 70%;
  padding: 5px;
  font-size: 18px;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  border: 1px solid #f0f0f0;
  background: #1197d6 !important;
  color: white;
}

#myModal {
  text-align: left;
}

@media (max-width: 768px) {
  .ibox {
    margin: 0px 0px 0px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue